module.exports = __webpack_public_path__ + "static/media/recruit_780_develop.f58e6c2b.png";